import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import MaterialIcon from '../../components/MaterialIcon/MaterialIcon';
import styles from './FAQ.module.scss';

interface FAQFilterProps {
  categories: string[];
  onSelectedCategory: (category: string) => void;
  selectedCategory: string | null;
}

export const FAQFilter: FC<FAQFilterProps> = ({ categories, selectedCategory, onSelectedCategory }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.faqFilterContainer}>
      <span className={styles.faqFilterTitle}>{`${t('faq:filter')}:`}</span>
      <div className={styles.faqFilterCategories}>
        {categories.map((category) => {
          const translatedCategory = t(`faqCategories:${category}`, { defaultValue: category });
          const isSelected = selectedCategory === category;

          return (
            <div
              className={classNames(styles.filterPillContainer, {
                ['partner-initial-border-color-rounded']: isSelected,
              })}
              key={category}
            >
              <button
                className={classNames(styles.filterPill, {
                  [styles.selectedFilter]: isSelected,
                })}
                onClick={() => onSelectedCategory(category)}
              >
                {translatedCategory}
                {isSelected &&
                  <MaterialIcon
                    className={styles.closeButton}
                    name="close"
                  />
                }
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
